import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import AltErrorWrapper
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import NotificationTemplateForm from './NotificationTemplateForm/NotificationTemplateForm';
import { EMAIL_TEMPLATE_TYPE, SMS_TEMPLATE_TYPE } from '../../../../utility/AlertNotificationTemplateUtils';

function NotificationTemplateFormInner({
  template,
  errorList,
  onFieldTextChange,
  updateCursorProperties,
  insertKeywordAtCaret,
  updateTemplate,
  resetTemplateByType,
  activeTierHasAdvancedAlerting,
}) {
  const [activeTab, setActiveTab] = useState('email');

  return (
    <FormErrorHandler errorList={errorList} fieldList={['name']}>
      <div className="row-col my-1">
        <AltErrorWrapper fieldId="name">
          <input
            type="text"
            aria-label="notification template name"
            className="form-control form-control-lg"
            placeholder="New Template"
            value={template.name}
            onChange={(e) => updateTemplate('name', e.target.value)}
          />
        </AltErrorWrapper>
      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mt-3 mb-5"
      >
        <Tab eventKey="email" title="Email Notifications" tabClassName="custom-tab">
          <div className={`form-group row ${!activeTierHasAdvancedAlerting && 'text-muted'} mb-2`}>
            <div className="col-sm-12">
              <div className="form-check-inline">
                <input
                  type="radio"
                  id="email-template-default"
                  checked={template.useDefaultEmailTemplate}
                  onChange={() => {
                    updateTemplate('useDefaultEmailTemplate', true);
                    resetTemplateByType(EMAIL_TEMPLATE_TYPE);
                  }}
                  className="form-check-input"
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="form-check-label" htmlFor="email-template-default">
                  Use default template
                </label>
              </div>
              <div className="form-check-inline">
                <input
                  type="radio"
                  id="email-template-custom"
                  checked={!template.useDefaultEmailTemplate}
                  onChange={() => updateTemplate('useDefaultEmailTemplate', false)}
                  className="form-check-input"
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="form-check-label" htmlFor="email-template-custom">
                  Use custom template
                </label>
              </div>
            </div>
          </div>
          {!template.useDefaultEmailTemplate && (
            <NotificationTemplateForm
              templateType={EMAIL_TEMPLATE_TYPE}
              template={template}
              onFieldTextChange={onFieldTextChange}
              updateCursorProperties={updateCursorProperties}
              insertKeywordAtCaret={insertKeywordAtCaret}
            />
          )}
        </Tab>
        <Tab eventKey="sms" title="SMS Notifications" tabClassName="custom-tab">
          <div className={`form-group row ${!activeTierHasAdvancedAlerting && 'text-muted'} mb-2`}>
            <div className="col-sm-12">
              <div className="form-check-inline">
                <input
                  type="radio"
                  id="sms-template-default"
                  checked={template.useDefaultSmsTemplate}
                  onChange={() => {
                    updateTemplate('useDefaultSmsTemplate', true);
                    resetTemplateByType(SMS_TEMPLATE_TYPE);
                  }}
                  className="form-check-input"
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="form-check-label" htmlFor="sms-template-default">
                  Default
                </label>
              </div>
              <div className="form-check-inline">
                <input
                  type="radio"
                  id="sms-template-custom"
                  checked={!template.useDefaultSmsTemplate}
                  onChange={() => updateTemplate('useDefaultSmsTemplate', false)}
                  className="form-check-input"
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="form-check-label" htmlFor="sms-template-custom">
                  Custom
                </label>
              </div>
            </div>
          </div>
          {!template.useDefaultSmsTemplate && (
            <NotificationTemplateForm
              templateType={SMS_TEMPLATE_TYPE}
              template={template}
              onFieldTextChange={onFieldTextChange}
              updateCursorProperties={updateCursorProperties}
              insertKeywordAtCaret={insertKeywordAtCaret}
            />
          )}
        </Tab>
      </Tabs>
    </FormErrorHandler>
  );
}

NotificationTemplateFormInner.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  template: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errorList: PropTypes.array.isRequired,
  onFieldTextChange: PropTypes.func.isRequired,
  updateCursorProperties: PropTypes.func.isRequired,
  insertKeywordAtCaret: PropTypes.func.isRequired,
  updateTemplate: PropTypes.func.isRequired,
  resetTemplateByType: PropTypes.func.isRequired,
  activeTierHasAdvancedAlerting: PropTypes.bool,
};

NotificationTemplateFormInner.defaultProps = {
  activeTierHasAdvancedAlerting: false,
};

export default NotificationTemplateFormInner;
